import { action, autorun, computed, flow, observable } from 'mobx';

import { API } from '../utilities';
import {
  NETWORK_OFFLINE,
  NETWORK_ONLINE,
  NETWORK_PING_INTERVAL,
  NETWORK_PING_TIMEOUT,
  NETWORK_PING_URL,
  NETWORK_SLOW,
  NETWORK_SLOW_RESPONSE_DURATION
} from '../utilities/constants';

export default class NetworkStore {
  intervalId = null;

  constructor(rootStore) {
    this.rootStore = rootStore;

    autorun(() => {
      if (typeof window !== 'undefined') {
        window.addEventListener('load', e => {
          this.status = navigator.onLine ? NETWORK_ONLINE : NETWORK_OFFLINE;
        });

        window.addEventListener('offline', e => {
          this.status = NETWORK_OFFLINE;
        });

        window.addEventListener('online', e => {
          this.status = NETWORK_ONLINE;
        });
      }

      if (this.rootStore.config.network && this.rootStore.config.network.pooling) {
        if (this.rootStore.chatWindow.isOpened && !this.isPooling) {
          this.startPooling(
            this.rootStore.config.network.pooling.url,
            this.rootStore.config.network.pooling.timeout,
            this.rootStore.config.network.pooling.interval
          );
          this.isPooling = true;
        }

        if (this.rootStore.chatWindow.isClosed && this.isPooling) {
          this.stopPooling();
          this.isPooling = false;
        }
      }
    });
  }

  @observable isPooling = false;

  @observable status = NETWORK_ONLINE;

  @computed get isOnline() {
    return this.status === NETWORK_ONLINE;
  }

  @computed get isSlowConnection() {
    return this.status === NETWORK_SLOW;
  }

  @computed get isOffline() {
    return this.status === NETWORK_OFFLINE;
  }

  ping = flow(function* ping(url = NETWORK_PING_URL, timeout = NETWORK_PING_TIMEOUT) {
    try {
      const response = yield API.head(url, {
        timeout,
        'axios-retry': {
          retries: 0
        }
      });

      if (response && response.duration && response.duration >= NETWORK_SLOW_RESPONSE_DURATION) {
        this.status = NETWORK_SLOW;
      } else {
        this.status = NETWORK_ONLINE;
      }
    } catch (error) {
      this.status = NETWORK_OFFLINE;
    }
  });

  @action startPooling(
    url = NETWORK_PING_URL,
    timeout = NETWORK_PING_TIMEOUT,
    interval = NETWORK_PING_INTERVAL
  ) {
    this.intervalId = setInterval(() => this.ping(url, timeout), interval);
  }

  @action stopPooling() {
    this.intervalId = clearInterval(this.intervalId);
  }
}
